const PARENT_PATHS = {
	DASHBOARD: '/dashboards',
	ACCOUNT: '/account',
	CALLS: '/calls',
	AGENTS: '/agents',
	FEEDBACK: '/feedback',
	ORGANISATION_MEMBER: '/organisation-member',
	BUSINESS_ACCOUNTS: '/business-accounts',
	AUTHENTICATION: '/authentication',
	CONFIG: '/configuration',
	STRIPE: '/stripe',
}

export const ROUTE_PATHS = {
	DASHBOARD: {
		ANALYTICS: `${PARENT_PATHS.DASHBOARD}/analytics`,
	},
	FEEDBACK: {
		BASE: `${PARENT_PATHS.FEEDBACK}`,
		NEW: `${PARENT_PATHS.FEEDBACK}/new`,
		TABLE: `${PARENT_PATHS.FEEDBACK}/table`,
		DETAIL: `${PARENT_PATHS.FEEDBACK}/:id`,
		CUSTOMER: `${PARENT_PATHS.FEEDBACK}/customer`,
	},
	ORGANISATION_MEMBER: {
		BASE: `${PARENT_PATHS.ORGANISATION_MEMBER}`,
		NEW: `${PARENT_PATHS.ORGANISATION_MEMBER}/new`,
		DETAIL: `${PARENT_PATHS.ORGANISATION_MEMBER}/:id`,
	},
	BUSINESS_ACCOUNTS: {
		BASE: `${PARENT_PATHS.BUSINESS_ACCOUNTS}`,
		NEW: `${PARENT_PATHS.BUSINESS_ACCOUNTS}/new`,
		DETAIL: `${PARENT_PATHS.BUSINESS_ACCOUNTS}/:id`,
	},
	AGENTS: {
		BASE: `${PARENT_PATHS.AGENTS}`,
		EDIT: `${PARENT_PATHS.AGENTS}/edit`,
		EDIT_DEFAULT: `${PARENT_PATHS.AGENTS}/edit/default`,
	},
	ACCOUNT: {
		SETTINGS: `${PARENT_PATHS.ACCOUNT}/settings`,
		NEW_USER: `${PARENT_PATHS.ACCOUNT}/user/new`,
	},
	CONFIG: {
		BASE: `${PARENT_PATHS.CONFIG}`,
		ORGANISATION: `${PARENT_PATHS.CONFIG}/organisation`,
		FEEDBACK: `${PARENT_PATHS.CONFIG}/feedback`,
		IMPORT: `${PARENT_PATHS.CONFIG}/import`,
	},
	AUTHENTICATION: {
		SIGN_IN: `${PARENT_PATHS.AUTHENTICATION}/sign-in`,
		RESET_PASSWORD: `${PARENT_PATHS.AUTHENTICATION}/reset-password`,
	},
	STRIPE: {
		SUCCESS: `${PARENT_PATHS.STRIPE}/success`,
		CANCEL: `${PARENT_PATHS.STRIPE}/cancel`,
	},
}
